import { component } from 'picoapp';

export default component(async (node) => {
  const trigger = node.querySelector('[aria-controls]');

  const init = () => {
    if (!trigger) return;

    const content = node.querySelector(`#${trigger.getAttribute('aria-controls')}`);
    const { height } = content.getBoundingClientRect();

    trigger.addEventListener('click', () => {
      node.classList.toggle('is-expanded');
      trigger.setAttribute('aria-expanded', node.classList.contains('is-expanded'));

      content.ariaHidden = !node.classList.contains('is-expanded');
      content.style.maxHeight = node.classList.contains('is-expanded') ? `${content.scrollHeight}px` : `${height}px`;
    });
  };

  init();
});
